import { z } from "zod";
import { dmaAmountUnitDtoSchema } from "./dma-amount-unit.schema";
export const dmaAmountDtoSchema = z.object({
    value: z.number(),
    unit: dmaAmountUnitDtoSchema,
});
